export const phoneIndicators = [
  {
    id: 1,
    country: 'FR',
    indicator: '+33',
  },
];
